<template>
    <div>
        <div class="bg-leave-liff">
            <div class="header-text line-register">
                {{ this.$vuetify.lang.t('$vuetify.lineRegister.headerRegister') }}
            </div>

            <line-register-result
                v-if="isRegistration"
                ref="lineRegisterResult"
                :result="registrationResult"
                @getBack="changState">
            </line-register-result>

            <v-form
                v-else
                ref="form"
                class="form-container">
                <div class="mt-2">
                    <div class="flex-center mt-4 mb-4">
                        <img src="@/assets/liff/welcome.png" />
                    </div>
                    <div class="title-text line-register">
                        พิมพ์รหัสการลงทะเบียน
                    </div>
                    <v-card-text class="card-input">
                        <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation>
                            <v-text-field
                                label="รหัสลงทะเบียน"
                                v-model="regCode"
                                autocomplete="off"
                                placeholder="ระบุรหัสลงทะเบียน"
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <div>
                        <v-row>
                            <v-col cols="12 flex-center">
                                <v-btn
                                    class="register-btn line-register"
                                    width="264"
                                    height="40"
                                    color="primary"
                                    @click="onSubmit()">
                                    ลงทะเบียน
                                </v-btn>
                            </v-col>
                            <v-col cols="12 flex-center mode-footer">
                                <span class="mode-select pr-2 line-register">
                                    หรือ
                                </span>
                                <span
                                    class="mode-pointer line-register"
                                    @click="toggleMode()">
                                    สแกน QR Code
                                </span>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-form>
            <div class="layuot-button"></div>
        </div>
    </div>
</template>

<script>
import LineRegisterResult from '@/components/Liff/LineRegisterResult'

export default {
    name: 'LineRegisterRegCode',

    components: {
        LineRegisterResult
    },

    data () {
        return {
            valid: false,
            regCode: '',
            isScanQR: true,
            isRegistration: false,
            registrationResult: {
                header: '',
                content: '',
                status: ''
            }
        }
    },
    props: {
        lineLiffId: {
            type: String,
            default: null
        },
        isConsent: {
            type: Boolean,
            default: false
        }
    },
    methods: {

        async scanCodeV2 () {
            const codeRegister = await this.$liffUtil.scanCodeV2(this.lineLiffId)

            if (codeRegister) {
                this.regCode = codeRegister
                await this.onSubmit()
            }
        },

        async onSubmit () {
            const lineUserId = await this.$liffUtil.getLineIdForLiff(this.lineLiffId)

            const body = {
                line_id: lineUserId,
                line_reg_code: this.regCode
            }

            this.$store.dispatch('setLoading', true)
            const res = await this.axios.post('line/register', body)
            if (res && res.data && res.data.status === 'ok') {
                this.registrationResult.header = 'ลงทะเบียนสำเร็จ'
                this.registrationResult.content = res.data.msg
                this.registrationResult.status = 'ok'
                this.$store.dispatch('setLoading', false)
            } else if (res && res.data && res.data.status === 'error_line') {
                this.registrationResult.header = 'ลงทะเบียนไม่สำเร็จ'
                this.registrationResult.content = res.data.msg
                this.registrationResult.status = 'error'
                this.$store.dispatch('setLoading', false)
            }

            this.isRegistration = true
        },

        async toggleMode () {
            if (this.isScanQR) {
                await this.scanCodeV2()
            }
            this.isScanQR = !this.isScanQR
        },

        changState (state) {
            this.isRegistration = state
        }
    },

    async mounted () {
        await this.scanCodeV2()
    }
}
</script>

<style lang="scss" scoped>
    .bg-leave-liff {
        background-color: #2E2929;
        color: #ffffff;
        height: 100vh;
    }

    .header-text {
        font-family: Prompt-Regular;
        font-size: 20px;
        padding: 1rem;
        height: 5%;
        min-height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .form-container {
        background: #ffffff;
        border-top-right-radius: 15px;
        border-top-left-radius: 15px;
        padding: 0.5rem 1rem 0.5rem 1rem;
        color: #6c6c6c;
        font-size: 14px;
        font-weight: normal;
        overflow: scroll;
        height: 95%;
        text-align: justify;
    }

    .title-text {
        font-family: Prompt-Medium;
        font-size: 18px;
        font-weight: 500;
        color: #131410;
        padding: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .flex-center {
        display: flex;
        justify-content: center;
    }

    .flex-no-warp {
        display: flex;
        flex-flow: column nowrap;
    }

    .register-scan {
        font-family: Prompt-Medium;
        font-size: 18px;
        color: #131410;
        font-weight: 500;
    }

    .register-btn {
        font-family: Prompt-Medium;
        font-size: 18px;
        padding: 1rem;
    }

    .mode-select {
        font-family: Prompt-Regular;
        font-size: 14px;
        color: #131410;
    }

    .mode-pointer {
        font-family: Prompt-Regular;
        font-size: 14px;
        cursor: pointer;
        color: #D76436;
        font-weight: 500;
    }

    .mode-footer {
        position: absolute;
        bottom: 0;
        right: 0;
        padding-bottom: 30px;
    }

    ::v-deep .v-btn[disabled] {
        background: #fdd2c0;
    }

    .layuot-button {
        padding: 30px;
    }
</style>
